<template>
  <div class="tooltip__container" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <div v-if="visible" class="tooltip" :class="position" :style="tooltipStyle">
      {{ text }}
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue';

export default {
  name: "Tooltip",
  props: {
    text: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'top',
    },
  },
  data() {
    return {
      visible: false,
      tooltipStyle: {
        top: '0px',
        left: '0px',
      },
    };
  },
  methods: {
    showTooltip(event) {
      this.visible = true;
      nextTick(() => {
        this.updateTooltipPosition(event);
      });
    },
    hideTooltip() {
      this.visible = false;
    },
    updateTooltipPosition(event) {
      const tooltip = this.$el.querySelector('.tooltip');
      if (!tooltip) return;

      const tooltipRect = tooltip.getBoundingClientRect();
      const targetRect = event.target.getBoundingClientRect();

      let top, left;

      switch (this.position) {
        case 'top':
          top = targetRect.top - tooltipRect.height - 10;
          left = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);
          break;
        case 'bottom':
          top = targetRect.bottom + 10;
          left = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);
          break;
        case 'left':
          top = targetRect.top + (targetRect.height / 2) - (tooltipRect.height / 2);
          left = targetRect.left - tooltipRect.width - 10;
          break;
        case 'right':
          top = targetRect.top + (targetRect.height / 2) - (tooltipRect.height / 2);
          left = targetRect.right + 10;
          break;
      }

      this.tooltipStyle.top = `${top}px`;
      this.tooltipStyle.left = `${left}px`;
    },
  },
};
</script>

<style scoped>
.tooltip__container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 1000;
  white-space: nowrap;
  pointer-events: none;
}

.tooltip::after {
  content: '';
  position: absolute;
  border-width: 5px;
  border-style: solid;
}

.tooltip.top::after {
  border-color: transparent;
  border-top-color: #333;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.tooltip.bottom::after {
  border-color: transparent;
  border-bottom-color: #333;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.tooltip.left::after {
  border-color: transparent;
  border-left-color: #333;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
}

.tooltip.right::after {
  border-color: transparent;
  border-right-color: #333;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
}
</style>
